import { array, object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  isFetchingBrands: false,
  isCategoriesOverlayVisible: false,
  isFiltersOverlayVisible: false,
  filtersOverlayInitialFilter: null,
  products: [],
  productCount: 0,
  filters: {
    tags: {
      male: [],
      female: [],
    },
    brands: [],
    types: [],
    categories: [],
  },
  activeFilters: {
    category: 'all', // all | bestsellers | newarrivals | featured
    brands: [],
    types: [],
    categories: [],
  },
}

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)

export const setFetchingBrands = (state, payload) => (
  { ...state, isFetchingBrands: payload }
)

export const setProducts = (state, payload) => (
  { ...state, products: payload, isFetching: false }
)

export const clearProducts = (state) => (
  { ...state, products: [] }
)

export const setProductCount = (state, payload) => (
  { ...state, productCount: payload }
)

export const setBrands = (state, payload) => (
  { ...state, isFetchingBrands: false, filters: { ...state.filters, brands: payload } }
)

export const setFilters = (state, { filter, values }) => (
  object.setIn(state, ['filters', filter], values)
)

export const setCategoriesOverlayVisibility = (state, payload) => (
  { ...state, isCategoriesOverlayVisible: payload }
)

export const setFiltersOverlayVisibility = (state, payload) => (
  { ...state, isFiltersOverlayVisible: payload }
)

export const setFiltersOverlayInitialFilter = (state, payload) =>
  ({ ...state, filtersOverlayInitialFilter: payload })

export const setActiveCategory = (state, payload /* category */) => (
  { ...state,
    activeFilters: {
      category: payload,
      tags: [],
      brands: [],
      types: [],
      categories: [],
    },
  }
)

export const clearFilters = (state) => (
  { ...state,
    activeFilters: {
      category: 'all',
      tags: [],
      brands: [],
      types: [],
      categories: [],
    },
  }
)

export const clearFilter = (state, payload) => (
  object.setIn(state, ['activeFilters', payload], [])
)

export const setActiveFilter = (state, { activeFilter, value }) => (
  object.updateIn(state, [ 'activeFilters', activeFilter ], () => value)
)

export const toggleActiveFilter = (state, { activeFilter, value }) => (
  object.updateIn(state, [ 'activeFilters', activeFilter ], (activeFilter) => array.toggle(activeFilter, value))
)

export const addFilterValue = (state, { filter, value }) => (
  object.updateIn(state, [ 'activeFilters', filter ], (filterName) => ([ ...filterName, value]))
)

export const removeFilterValue = (state, { filter, value }) => (
  object.updateIn(state, [ 'activeFilters', filter ], (filterName) =>
    filterName.filter((name) => name !== value)
  )
)

export const toggleActiveBrand = (state, payload /* brandName */) => (
  object.update(state, 'activeFilters', (activeFilters) => ({
    ...activeFilters,
    category: 'all',
    brands: array.toggle(activeFilters.brands, payload),
  }))
)
